<div class="select-container">
  <div class="select-button" (click)="handleButtonClick($event)" [matMenuTriggerFor]="dropdownMenu" [matTooltip]="selectedOptionText | tooltip"
    *ngIf="customInputType !== 'disabled';else disabledInput">
    <div class="button-text"  [ngClass]="{'placeholder': !isOptionSelected, 'selected': isOptionSelected}">
      {{ selectedOptionText }}
    </div>

    <div class="button-icon">
      <img src="assets/icons/keyboard_arrow_down_new.svg">
    </div>
  </div>

  <ng-template #disabledInput>
    <div class="disabled-input">Select an option</div>
  </ng-template>

  <mat-menu [class]="('select-list' | className: dropDownWidth)" #dropdownMenu="matMenu" xPosition="before"
    yPosition="below" (closed)="onMatMenuClosed()">
    <div class="container-header">
      <div class="header-title">{{ topicsLabels.select_option }} </div>
      <div class="columns-count">{{ topicCount }} {{topicsLabels.options}}</div>
    </div>
    <div class="option-search-container">
      <input type="text" [(ngModel)]="searchQuery" placeholder="Search" (click)="stopPropagation($event)"
        class="custom-input">
      <span class="close-icon" *ngIf="searchQuery" (click)="clearSearch(); $event.stopPropagation()">
        <img src="../../../assets/icons/close.svg">
      </span>
    </div>

    <div class="columns-list">
      <div class="column-item" *ngFor="let item of getPrimaryTopics; trackBy: trackByLabel" (click)="stopPropagation($event)">
        <div class="column-name">{{ item.label }}</div>
        <div class="toggle">
          <toggle [toggleOn]="item.tempIsSelected" (toggledTo)="onValueChange($event, item)"></toggle>
        </div>
      </div>
    </div>
  </mat-menu>
</div>
